import {
    takeEvery, call, put, fork
  } from 'redux-saga/effects';
  import { loadIsler, saveIsler } from 'src/utils/storage/WorkOrder';
  import * as actions from '../actions/taskActions';
  import * as api from '../api/tasks';
  
  function* getActionRequired() {
    try {
      let result = '';
      if (window.navigator.onLine) {
        result = yield call(api.getActionRequired);
        yield put(actions.getTasksSuccess(result.data));
      } else {
        result = loadIsler();
        yield put(actions.getTasksSuccess(result));
      }
    } catch (error) {
      const resultError = loadIsler();
      yield put(actions.getTasksSuccess(resultError));
    }
  }
  
  function* watchGetTaskRequest() {
    yield takeEvery(actions.Types.GET_ACTIONREQUIRED_REQUEST, getActionRequired);
  }
  
  const actionrequiredSagas = [fork(watchGetTaskRequest)];
  
  export default actionrequiredSagas;
  